module.exports = __webpack_public_path__ + "img/sunrisers-eastern-cape-logo-icon.1efcb90f.png";